<h1>TinyMCE 5 Angular Demo</h1>
<editor
        [(ngModel)]="content"

        [init]="initObject"
        (onInit)="angularInit()"
        (onSetContent)="angularSetContent()"
        (onInitNgModel)="realAngularInit($event)"></editor>

<textarea [(ngModel)]="content" style="width: 100%;" rows="10"></textarea>
